import { ptBR } from "./ptbr";
import { en } from "./en";

export default {
  "pt-BR": ptBR,
  pt: ptBR,
  "pt-PT": ptBR,
  en: en,
  "en-US": en,
  "en-GB": en,
  "en-ES": en,
  "en-CA": en,
};
